import ChsAddress from 'domain/types/ChsAddress';

const keys: (keyof ChsAddress)[] = [
  'houseNumber',
  'halfNumber',
  'streetDir',
  'streetName',
  'streetType',
  'unitNumber',
  'city',
  'state',
  'zipCode',
  'country',
  'unitType',
  'singleFamilyHome',
];

export default function compareAddress(a: ChsAddress, b: ChsAddress) {
  if (!a || !b) {
    return false;
  }
  for (const key in a) {
    if (!keys.includes(key)) {
      continue;
    }
    if (Object.prototype.hasOwnProperty.call(a, key)) {
      if (a[key] !== b[key]) {
        return false;
      }
    }
  }

  return true;
}
